'use client';

import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { VscMenu } from "react-icons/vsc";
import { IoMdClose } from "react-icons/io";
import { RiLoginCircleFill } from "react-icons/ri";
import { VscAccount } from "react-icons/vsc";
import { useSession } from "next-auth/react";
import { useRouter, usePathname } from 'next/navigation';
import { Link } from '@/i18n/routing';
import AuthPopup from '../login-order/loginOrdinaryPopup';
import { CgMenuRight } from "react-icons/cg";
import { useTranslations } from 'next-intl';
const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const { data: session, status } = useSession();
  const router = useRouter();
  const pathname = usePathname();
  const th = useTranslations('Padel-Master-The-Game-Home-header');
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const close = () => setIsOpen(false);

  const scrollToSection = (id: string) => {
    close();
    if (pathname === '/') {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      router.push(`/#${id}`);
    }
  };

  const openLogin = () => {
    close();
    setIsAuthOpen(true);
  };

  const navItems = [
    { num: '01', label:  th("Summary") ,    action: () => scrollToSection('content') },
    { num: '02', label:  th("eBook-Pack"), action: () => scrollToSection('pack') },
    { num: '03', label:  th("Contact-Us"), action: () => { close(); router.push('/contact-us'); } },
  ];

  const overlay = (
    <div
      className={`
        fixed inset-0 flex flex-col lg:hidden opacity-95 bg-a text-lg
        transition-transform duration-[400ms] ease-[cubic-bezier(0.76,0,0.24,1)]
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}
      style={{
      
        zIndex: 99999,
        backdropFilter: 'none',
        WebkitBackdropFilter: 'none',
      }}
    >
      {/* Header */}
      <div
        className="flex justify-between items-center px-6 py-5 bg-secondary"
        style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <span
          className="uppercase text-xl lg:text-2xl font-extrabold text-b">
          {th("logo")} 
        </span>
        <button onClick={close} aria-label="Close menu" className="text-b">
          <IoMdClose style={{ width: 28, height: 28 }} />
        </button>
      </div>

      {/* Nav links */}
      <nav className="flex flex-col flex-1 px-6 py-10">
        {navItems.map((item, i) => (
          <button
            key={item.num}
            onClick={item.action}
            className="flex items-center gap-4 w-full text-left text-white group"
            style={{
              padding: '24px 0',
              borderBottom: '1px solid rgba(255,255,255,0.07)',
              opacity: isOpen ? 1 : 0,
              transform: isOpen ? 'translateX(0)' : 'translateX(-20px)',
              transition: `opacity 0.4s ease ${0.08 + i * 0.07}s, transform 0.4s ease ${0.08 + i * 0.07}s`,
            }}
          >
            <span
              className="font-bold font-mono"
              style={{ fontSize: 11, color: 'rgba(255,255,255,0.2)', minWidth: 24 }}
            >
              {item.num}
            </span>
            <span
              className="font-extrabold uppercase"
             
            >
              {item.label}
            </span>
            <span className="ml-auto" style={{ fontSize: 20, opacity: 0.3 }}>→</span>
          </button>
        ))}

        {/* Login / Account */}
        {status === 'authenticated' ? (
          <Link
            href="/account"
            onClick={close}
            className="flex items-center gap-4 text-b text-lg"
            style={{
              padding: '24px 0',
              borderBottom: '1px solid rgba(255,255,255,0.07)',
            
              opacity: isOpen ? 1 : 0,
              transform: isOpen ? 'translateX(0)' : 'translateX(-20px)',
              transition: `opacity 0.4s ease ${0.08 + navItems.length * 0.07}s, transform 0.4s ease ${0.08 + navItems.length * 0.07}s`,
            }}
          >
            <span
              className="font-bold font-mono"
              style={{ fontSize: 11, color: 'rgba(255,255,255,0.2)', minWidth: 24 }}
            >
              {String(navItems.length + 1).padStart(2, '0')}
            </span>
            <span
              className="font-extrabold uppercase "
             
            >
             {th("Account")} 
            </span>
            <VscAccount style={{ marginLeft: 'auto', width: 24, height: 24, opacity: 0.6 }} />
          </Link>
        ) : (
          <button
            onClick={openLogin}
            className="flex items-center gap-4 w-full text-left text-b text-lg"
            style={{
              padding: '24px 0',
              borderBottom: '1px solid rgba(255,255,255,0.07)',
             
              opacity: isOpen ? 1 : 0,
              transform: isOpen ? 'translateX(0)' : 'translateX(-20px)',
              transition: `opacity 0.4s ease ${0.08 + navItems.length * 0.07}s, transform 0.4s ease ${0.08 + navItems.length * 0.07}s`,
            }}
          >
            <span
              className="font-bold font-mono"
              style={{ fontSize: 11, color: 'rgba(255,255,255,0.2)', minWidth: 24 }}
            >
              {String(navItems.length + 1).padStart(2, '0')}
            </span>
            <span
              className="font-extrabold uppercase"
             
            >
            {th("Login-Sign")}
            </span>
            <RiLoginCircleFill style={{ marginLeft: 'auto', width: 24, height: 24, opacity: 0.6 }} />
          </button>
        )}
      </nav>

      {/* Footer */}
      <div
        className="px-6 py-6 flex gap-6"
        style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
      >
        <span className="text-xs uppercase text-white" style={{ opacity: 0.3, letterSpacing: '0.1em' }}>
          © 2026  {th("logo")} 

        </span>
      </div>
    </div>
  );

  return (
    <>
      {/* Hamburger */}
      <button
        onClick={() => setIsOpen(true)}
        aria-label="Open menu"
        className="flex xl:hidden text-b"
      >
        <CgMenuRight size={22} />
      </button>

      {/* Portal — renders on document.body, escapes navbar CSS context */}
      {mounted && createPortal(overlay, document.body)}

      {/* Auth popup */}
      <AuthPopup
        isOpen={isAuthOpen}
        onClose={() => setIsAuthOpen(false)}
        initialMode="login"
      />
    </>
  );
};

export default MobileMenu;